import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { GridPlugin } from "@syncfusion/ej2-vue-grids";

const initialize = (vue) => {
  vue.use(CheckBoxPlugin);
  vue.use(GridPlugin);
};

export default initialize;
